export enum MAINSCREEN_RESULT_STEPS {
  INITIAL = "INITIAL",
  CORRECTNESS = "CORRECTNESS",
  COMPLETE = "COMPLETE",
  RESULT = "RESULT",
}

export enum APP_MODE {
  GAME = "GAME",
  WORDLIST = "WORDLIST",
}

export enum OperatorModel {
  ADDITION = "addition",
  SUBSTRACTION = "subtraction",
}

export interface MathProblem {
  id: string;
  operand1: number;
  operand2: number;
  operator: OperatorModel;
  difficulty: number;
  level: string;
}

export type ValidationStatusModel = "success" | "fail";
export type DigitalNumberBoxSize = "lg" | "md" | "sm";

export interface ProblemDifficultyLevel {
  difficulty: number;
  level: string;
}

export interface TransModel {
  id: string;
  defaultMessage?: string;
}
